import * as React from "react";
import PropTypes from "prop-types";

import Box from "@mui/material/Box";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Button from "@mui/material/Button";
import Container from "@mui/material/Container";
import Divider from "@mui/material/Divider";
import Typography from "@mui/material/Typography";
import MenuItem from "@mui/material/MenuItem";
import Drawer from "@mui/material/Drawer";
import MenuIcon from "@mui/icons-material/Menu";
import ToggleColorMode from "./ToggleColorMode";
import logo from "../assets/footer/reseltech.jpg";
import { Link } from 'react-router-dom';

const logoStyle = {
  width: "180px",
  height: "80px",
 // objectFit: "contain",
  borderRadius: "8px",
  cursor: "pointer",
};

function Header({ mode, toggleColorMode }) {
  const [open, setOpen] = React.useState(false);

  const toggleDrawer = (newOpen) => () => {
    setOpen(newOpen);
  };

  const scrollToSection = (sectionId) => {
    const sectionElement = document.getElementById(sectionId);
    const offset = 128;
    if (sectionElement) {
      const targetScroll = sectionElement.offsetTop - offset;
      sectionElement.scrollIntoView({ behavior: "smooth" });
      window.scrollTo({
        top: targetScroll,
        behavior: "smooth",
      });
      setOpen(false);
    }
  };

  return (
    <div>
      <AppBar
        position="fixed"
        sx={{
          boxShadow: 0,
          bgcolor: "transparent",
          backgroundImage: "none",
          mt: 2,
        }}
      >
        <Container maxWidth="lg">
          <Toolbar
            variant="regular"
            sx={(theme) => ({
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              flexShrink: 0,
              borderRadius: "999px",
              bgcolor:
                theme.palette.mode === "light"
                  ? "rgba(255, 255, 255, 0.4)"
                  : "rgba(0, 0, 0, 0.4)",
              backdropFilter: "blur(24px)",
              maxHeight: 40,
              border: "1px solid",
              borderColor: "divider",
              boxShadow:
                theme.palette.mode === "light"
                  ? `0 0 1px rgba(85, 166, 246, 0.1), 1px 1.5px 2px -1px rgba(85, 166, 246, 0.15), 4px 4px 12px -2.5px rgba(85, 166, 246, 0.15)`
                  : "0 0 1px rgba(2, 31, 59, 0.7), 1px 1.5px 2px -1px rgba(2, 31, 59, 0.65), 4px 4px 12px -2.5px rgba(2, 31, 59, 0.65)",
            })}
          >
            <Box
              sx={{
                flexGrow: 1,
                display: "flex",
                alignItems: "center",
                ml: "-18px",
                px: 0,
              }}
            >
           <Typography
                variant="h6"
                //component="div"
                 component={Link}
                to="/"
                sx={{
                  fontWeight: "bold",
                  fontSize: "1.5rem",
                  color: "primary.main",
                  textDecoration: "none",
                  cursor: "pointer",
                  mr: 2,
                }}
              >
                Reseltech
              </Typography>
              {/* <img
                src={
                  logo
                }
                style={logoStyle}
                  sx={{
    width: "180px",
    height: "80px",
    objectFit: "contain",
    borderRadius: "8px",
    cursor: "pointer",
  }}
                alt="logo of sitemark"
              /> */}
              <Box sx={{ display: { xs: "none", md: "flex" } }}>
                <MenuItem
                  // onClick={() => scrollToSection('features')}
                  component={Link} // Use the Link component from React Router DOM
                  to="/" // Specify the destination path
                  sx={{ py: "6px", px: "12px" }}
                >
                  <Typography variant="body2" color="text.primary">
                    Home
                  </Typography>
                </MenuItem>
                <MenuItem
                  //onClick={() => scrollToSection("testimonials")}
                  component={Link} 
                  to="/about"
                  sx={{ py: "6px", px: "12px" }}
                >
                  <Typography variant="body2" color="text.primary">
                    About Us
                  </Typography>
                </MenuItem>
                <MenuItem
                  //onClick={() => scrollToSection("highlights")}
                  component={Link} 
                  to="/acidtech" 
                  sx={{ py: "6px", px: "12px" }}
                >
                  <Typography variant="body2" color="text.primary">
                    Technology
                  </Typography>
                </MenuItem>
                <MenuItem
                  //onClick={() => scrollToSection("pricing")}
                  component={Link} 
                  to="/tool" 
                  sx={{ py: "6px", px: "12px" }}
                >
                  <Typography variant="body2" color="text.primary">
                    Downhole Tools
                  </Typography>
                </MenuItem>
                <MenuItem
                  //onClick={() => scrollToSection("faq")}
                  component={Link} 
                  to="/contact"
                  sx={{ py: "6px", px: "12px" }}
                >
                  <Typography variant="body2" color="text.primary">
                    Contact Us
                  </Typography>
                </MenuItem>
              </Box>
            </Box>
            <Box
              sx={{
                display: { xs: "none", md: "flex" },
                gap: 0.5,
                alignItems: "center",
              }}
            >
              {/* <ToggleColorMode mode={mode} toggleColorMode={toggleColorMode} /> */}
              {/* <Button
                color="primary"
                variant="text"
                size="small"
                component="a"
                //href="/material-ui/getting-started/templates/sign-in/"
                target="_blank"
              >
                Sign in
              </Button>
              <Button
                color="primary"
                variant="contained"
                size="small"
                component="a"
                //href="/material-ui/getting-started/templates/sign-up/"
                target="_blank"
              >
                Sign up
              </Button> */}
            </Box>
            <Box sx={{ display: { sm: "", md: "none" } }}>
              <Button
                variant="text"
                color="primary"
                aria-label="menu"
                onClick={toggleDrawer(true)}
                sx={{ minWidth: "30px", p: "4px" }}
              >
                <MenuIcon />
              </Button>
              <Drawer anchor="right" open={open} onClose={toggleDrawer(false)}>
                <Box
                  sx={{
                    minWidth: "60dvw",
                    p: 2,
                    backgroundColor: "background.paper",
                    flexGrow: 1,
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "end",
                      flexGrow: 1,
                    }}
                  >
                    {/* <ToggleColorMode
                      mode={mode}
                      toggleColorMode={toggleColorMode}
                    /> */}
                  </Box>
                  <MenuItem 
                  //onClick={() => scrollToSection("features")}
                  component={Link} 
                  to="/"
                  >
                    Home
                  </MenuItem>
                  <MenuItem 
                  //onClick={() => scrollToSection("testimonials")}
                  component={Link} 
                  to="/about"
                  >
                   About Us
                  </MenuItem>
                  <MenuItem 
                 // onClick={() => scrollToSection("highlights")}
                 component={Link} 
                 to="/acidtech" 
                  >
                    Technology
                  </MenuItem>
                  <MenuItem 
                  //onClick={() => scrollToSection("pricing")}
                  component={Link} 
                  to="/tool"   
                  >
                    DownHole Tools
                  </MenuItem>
                  {/* <MenuItem onClick={() => scrollToSection("faq")}>
                    FAQ
                  </MenuItem> */}
                  <MenuItem
                  //onClick={() => scrollToSection("faq")}
                  component={Link} 
                  to="/contact"
                  sx={{ py: "6px", px: "12px" }}
                >
                  Contact Us
                </MenuItem>
                  <Divider />
                  {/* <MenuItem>
                    <Button
                      color="primary"
                      variant="contained"
                      component="a"
                      //href="/material-ui/getting-started/templates/sign-up/"
                      target="_blank"
                      sx={{ width: "100%" }}
                    >
                      Sign up
                    </Button>
                  </MenuItem>
                  <MenuItem>
                    <Button
                      color="primary"
                      variant="outlined"
                      component="a"
                      //href="/material-ui/getting-started/templates/sign-in/"
                      target="_blank"
                      sx={{ width: "100%" }}
                    >
                      Sign in
                    </Button>
                  </MenuItem> */}
                </Box>
              </Drawer>
            </Box>
          </Toolbar>
        </Container>
      </AppBar>
    </div>
  );
}

Header.propTypes = {
  mode: PropTypes.oneOf(["dark", "light"]).isRequired,
  toggleColorMode: PropTypes.func.isRequired,
};

export default Header;
